import {
  createFileRoute,
  lazyRouteComponent,
  redirect,
} from '@tanstack/react-router';

export const Route = createFileRoute('/(client)/capa/(pages)/(list)/findings')({
  beforeLoad: ({ location }) => {
    if (
      location.pathname === '/capa/findings' ||
      location.pathname === '/capa/findings/'
    ) {
      throw redirect({ to: '/capa/findings/active' });
    }
  },
  component: lazyRouteComponent(
    () => import('../../../-components/FindingsLayout'),
    'FindingsLayout',
  ),
});
